import React from "react";
import BuyerPlans from "./components/buyer-plans/buyer-plans";
import SellerPlans from "./components/seller-plans/seller-plans";
import VacantLandPlans from "./components/vacant-land-plans/vacant-land-plans";
import appStyles from "../../app.module.css";

const Plans = () => {
  return (
    <>
      <BuyerPlans />
      <hr className={appStyles.rezziSeperator} />
      <SellerPlans />
      <hr className={appStyles.rezziSeperator} />
      <VacantLandPlans />
    </>
  );
};

export default Plans;
